import React, { Component } from 'react';

class ProductRow extends Component {
  render() {
    const { image, name, price, status } = this.props;

    const styles = {
      row: {
        textAlign: 'center',
        transition: 'background-color 0.3s',
      },
      cell: {
        padding: '15px',
        borderBottom: '1px solid #dee2e6',
      },
      image: {
        width: '60px',
        height: '60px',
        objectFit: 'cover',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      },
      status: (status) => ({
        color: status === 'Sold' ? '#dc3545' : '#28a745',
        fontWeight: 'bold',
      }),
    };

    return (
      <tr style={styles.row}>
        <td style={styles.cell}>
          <img src={image} alt={name} style={styles.image} />
        </td>
        <td style={styles.cell}>{name}</td>
        <td style={styles.cell}>{price} DT</td>
        <td style={{ ...styles.cell, ...styles.status(status) }}>{status}</td>
      </tr>
    );
  }
}

export default ProductRow;
